import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/vip.png'


const _hoisted_1 = { class: "menu-base" }
const _hoisted_2 = { class: "menu-content" }
const _hoisted_3 = { class: "menu-item info" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  key: 0,
  class: "menu-item"
}

import {
  showVIPDialogue,
  showUserServiceDialogue,
  showLogoutDialogue,
  openVIP,
  openService,
} from "@/components/Dialogues/useData/useDialogues";

import { computed } from "vue";

import publicStore from "@/store/publicStore";
import { storeToRefs } from "pinia";
import { ElMessage } from "element-plus";

export default /*@__PURE__*/_defineComponent({
  __name: 'UserMenu',
  setup(__props) {

const { userInfo, vipInfo, vipDisplay } = storeToRefs(publicStore());

return (_ctx: any,_cache: any) => {
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Connection = _resolveComponent("Connection")!
  const _component_Service = _resolveComponent("Service")!
  const _component_Close = _resolveComponent("Close")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(userInfo).nickName), 1),
        _createElementVNode("div", _hoisted_5, "ID: " + _toDisplayString(_unref(userInfo).uid), 1)
      ]),
      _createElementVNode("div", {
        class: "menu-item",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(openVIP) && _unref(openVIP)(...args)))
      }, [
        _cache[4] || (_cache[4] = _createElementVNode("img", {
          class: "vip-icon",
          src: _imports_0,
          alt: "",
          srcset: ""
        }, null, -1)),
        _createElementVNode("div", null, _toDisplayString(_unref(vipDisplay)), 1)
      ]),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_el_icon, { size: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_Setting)
              ]),
              _: 1
            }),
            _cache[5] || (_cache[5] = _createElementVNode("div", null, "系统设置", -1))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "menu-item",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (showUserServiceDialogue.value = true))
      }, [
        _createVNode(_component_el_icon, { size: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_Connection)
          ]),
          _: 1
        }),
        _cache[6] || (_cache[6] = _createElementVNode("div", null, "关于我们", -1))
      ]),
      _createElementVNode("div", {
        class: "menu-item",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(openService) && _unref(openService)(...args)))
      }, [
        _createVNode(_component_el_icon, { size: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_Service)
          ]),
          _: 1
        }),
        _cache[7] || (_cache[7] = _createElementVNode("div", null, "联系客服", -1))
      ]),
      _createElementVNode("div", {
        class: "menu-item",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (showLogoutDialogue.value = true))
      }, [
        _createVNode(_component_el_icon, { size: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_Close)
          ]),
          _: 1
        }),
        _cache[8] || (_cache[8] = _createElementVNode("div", null, "退出登录", -1))
      ])
    ])
  ]))
}
}

})